<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.notify_title" placeholder="请输入通知标题" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="articleTitle" label="文章标题"></el-table-column>
            <el-table-column prop="articleImage" label="文章图片">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="img" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.articleImage)" :initial-index="index"
                        v-for="(img, index) in getThumbImageSrcList(scope.row.articleImage)"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="articleSort" label="序号"></el-table-column>
            <el-table-column prop="articleStatus" label="状态"></el-table-column>
            <el-table-column prop="articleDesc" label="简述"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.articleDate) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="80%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="标题">
                        <el-input v-model="handleInfo.articleTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('articleImage')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('articleImage', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'articleImage' }" accept=".jpg,.jpeg,.bmp,.png"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="序号">
                        <el-input v-model="handleInfo.articleSort"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="handleInfo.articleStatus" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in statusArray" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="简述">
                        <el-input v-model="handleInfo.articleDesc"></el-input>
                    </el-form-item>
                    <el-form-item label="内容">
                        <quill-editor v-model="handleInfo.articleContent" style="width: 100%; height: 600px; margin-bottom: 10px;"></quill-editor>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            productArray: [],
            statusArray: [
                {
                    name: "启用",
                    value: 1
                },
                {
                    name: "禁用",
                    value: 0
                }
            ]
        }
    },
    methods: {
    },
    created: async function () {
        this.tag = "ARTICLE";
        this.uploads.push({
            column: "articleImage",
            files: []
        });
        this.productArray = await doGet(API.ALL.PRODUCT);
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>